'use strict';

angular.module('shiftTraderApp')
  .controller('Lightbox', ['$scope', '$uibModalInstance', '$timeout', 'params', 'uuid4', function ($scope, $uibModalInstance, $timeout, params, uuid4) {
    $scope.state = {
      media: params.media,
      currentMediaIndex: params.currentMediaIndex,
      primaryImageSource: null,
      downloadUrl: null,
      vjsReady: false,
      player: null,
      numTimeUpdates: 0,
      uuid: null,
      q: {

      }
    };

    var throttledAnalytics = _.throttle(function() {
      var duration = $scope.state.player.duration();
      var currentTime = $scope.state.player.currentTime();

      var percent = currentTime / duration;

      $scope.state.media[$scope.state.currentMediaIndex].track('progress', $scope.state.uuid, currentTime, duration);
    }, 10000);

    /**
     * Select an image as the current image from the thumbnail-belt.
     * @param  {integer} index Index of the image to select
     */
    $scope.selectImage = function(index) {
      // If we selected a different video, reset the video-js ready flag
      if (index != $scope.state.currentMediaIndex) {
        $scope.state.vjsReady = false;
      }

      var obj = $scope.state.media[index];

      // Set the video-js and image settings based on the current selection
      $scope.state.media[$scope.state.currentMediaIndex]._selected = false;
      obj._selected = true;
      if (obj._video) {
        $scope.state.vjsMedia = {
          "sources": [{
            "type": "video/" + obj.service_type,
            "src": obj.generateUrl()
          }]
        };
      } else {
        var isImage = !obj.file_type || obj.file_type.search('image') !== -1;

        $scope.state.downloadUrl = 'https://cdn.filestackcontent.com/' + obj.external_id;

        if (isImage) {
          $scope.state.primaryImageSource = 'https://cdn.filestackcontent.com/' + obj.external_id;
        } else if (obj.file_type.search('pdf') !== -1) {
          $scope.state.primaryImageSource = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_PDF.png';
        } else if (obj.file_type.search('word') !== -1) {
          $scope.state.primaryImageSource = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_Document.png';
        } else if (obj.file_type.search('powerpoint') !== -1) {
          $scope.state.primaryImageSource = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_Presentation.png';
        } else if (obj.file_type.search('excel') !== -1) {
          $scope.state.primaryImageSource = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_Spreadsheet.png';
        }

        var style = {
          'background-image': 'url(\'' + $scope.state.primaryImageSource + '\')',
          'background-size': (isImage) ? 'contain': 'auto'
        };

        $timeout(function() {
          $('.lightbox .primary-container .primary-image').css(style);
        }, 0);
      }
      $scope.state.currentMediaIndex = index;
    };

    // Initialization function: set flags, initialize default values
    (function() {
      // Setting flags
      _.each($scope.state.media, function(m) {
        m._video = (m.service_type == 'youtube' || m.service_type == 'vimeo');
        m._selected = false;
      });

      // Setup default settings for the video-js directive
      var curr = $scope.state.media[$scope.state.currentMediaIndex];
      $scope.state.vjsSetup = {
        "techOrder": ['youtube', 'vimeo'],
        "fluid": true
      };
      if (curr._video) {
        $scope.state.vjsMedia = {
          "sources": [{
            "type": "video/" + curr.service_type,
            "src": curr.generateUrl()
          }]
        };
      }
    })();

    // Select the default image
    $scope.selectImage($scope.state.currentMediaIndex);

    // Watch for the video being ready so the video placeholder can be removed
    $scope.$on('vjsVideoReady', function (e, data) {
      $scope.$apply(function() {
        $scope.state.vjsReady = true;
        $scope.state.player = data.player;
        $scope.state.uuid = uuid4.generate();

        $scope.state.player.ready(function() {
          this.on('timeupdate', function() {
            $scope.state.numTimeUpdates += 1;
            if ($scope.state.numTimeUpdates <= 1) {
              $scope.state.media[$scope.state.currentMediaIndex].track('play', $scope.state.uuid);
              return;
            }

            throttledAnalytics();
          });
        });
      });
    });

    $scope.close = function() {
      console.log('Closing Lightbox');
    };

    $scope.done = function() {
      console.log('Done Lightbox');
    };
  }]);
